import { ReactNode } from "react";
import {
  AnalyticsOutlined,
  BuildOutlined,
  EmojiEventsOutlined,
  GroupOutlined,
  GroupsOutlined,
  ReportProblemOutlined,
  SpeakerNotesOutlined,
  TocOutlined,
  UploadOutlined,
  WorkOutlineOutlined,
  Notifications as NotificationsIcon,
  StoreOutlined,
  Mic,
  Web,
  Person,
  Article,
  LocalHospitalOutlined,
} from "@mui/icons-material";

export const iconsConstants: Record<string, ReactNode> = {
  users: <GroupsOutlined />,
  clientMapping: <GroupOutlined />,
  schemes: <TocOutlined />,
  fileUpload: <UploadOutlined />,
  needs: <ReportProblemOutlined />,
  surveys: <SpeakerNotesOutlined />, // surveys moduleName in your code
  surveyors: <Person />,
  jobs: <WorkOutlineOutlined />,
  services: <BuildOutlined />,
  merchants: <StoreOutlined />,
  notifications: <NotificationsIcon />,
  'landing-page': <Web />,
  rewards: <EmojiEventsOutlined />,
  cms: <Article />,
  hospitals: <LocalHospitalOutlined />,
};